module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.3864daf5.svg";